import { render } from "./SellerRankingLink.vue?vue&type=template&id=9ac662aa&ts=true"
import script from "./SellerRankingLink.vue?vue&type=script&lang=ts"
export * from "./SellerRankingLink.vue?vue&type=script&lang=ts"

import "./SellerRankingLink.vue?vue&type=style&index=0&id=9ac662aa&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__